import { useAuthStore } from '@/stores/authStore';
import { useAccountStore } from '@/stores/accountStore';

function signature(): string {
  const { user, status } = useAuthStore.getState();
  return JSON.stringify([status, user?.id ?? null, user?.orgId ?? null,
    user?.role ?? null, useAccountStore.getState().keyMode]);
}
let generation = 0;
let lastSignature = signature();
/** Changes monotonically across A-B-A, including changes batched by React.
 * Does not include Kalshi connectivity: a Kalshi reconnect is not a change
 * of Polymarket account authority. Token refresh alone also keeps the scope. */
export function polyAccountReadScope(): string {
  const next = signature();
  if (next !== lastSignature) { lastSignature = next; generation++; }
  return JSON.stringify([generation, lastSignature]);
}
const stopAuth = useAuthStore.subscribe(polyAccountReadScope);
const stopAccount = useAccountStore.subscribe(polyAccountReadScope);
if (import.meta.hot) import.meta.hot.dispose(() => { stopAuth(); stopAccount(); });

/** The server independently authorizes every network operation. */
export function capturePolyActionScope(expectedScope: string) {
  return { current: () => polyAccountReadScope() === expectedScope };
}
